import { Converter } from '../types/converter';

export const specificHeatCapacityConverter: Converter = {
  id: 'specificHeatCapacity',
  name: 'Specific Heat Capacity Converter',
  icon: 'Thermometer',
  categories: ['engineering', 'heat'],
  units: [
    // SI units
    { name: 'Joule/Kilogram/Kelvin', symbol: 'J/(kg·K)', factor: 1 },
    { name: 'Joule/Kilogram/Degree Celsius', symbol: 'J/(kg·°C)', factor: 1 },
    { name: 'Joule/Gram/Degree Celsius', symbol: 'J/(g·°C)', factor: 1000 },
    { name: 'Kilojoule/Kilogram/Kelvin', symbol: 'kJ/(kg·K)', factor: 1000 },
    { name: 'Kilojoule/Kilogram/Degree Celsius', symbol: 'kJ/(kg·°C)', factor: 1000 },
    
    // Calorie-based units
    { name: 'Calorie (IT)/Gram/Degree Celsius', symbol: 'cal (IT)/(g·°C)', factor: 4186.8 },
    { name: 'Calorie (IT)/Gram/Degree Fahrenheit', symbol: 'cal (IT)/(g·°F)', factor: 2326 },
    { name: 'Calorie (th)/Gram/Degree Celsius', symbol: 'cal (th)/(g·°C)', factor: 4184 },
    { name: 'Kilocalorie (IT)/Kilogram/Degree Celsius', symbol: 'kcal (IT)/(kg·°C)', factor: 4186.8 },
    { name: 'Kilocalorie (th)/Kilogram/Degree Celsius', symbol: 'kcal (th)/(kg·°C)', factor: 4184 },
    { name: 'Kilocalorie (IT)/Kilogram/Kelvin', symbol: 'kcal (IT)/(kg·K)', factor: 4186.8 },
    { name: 'Kilocalorie (th)/Kilogram/Kelvin', symbol: 'kcal (th)/(kg·K)', factor: 4184 },
    
    // Force-based units
    { name: 'Kilogram-Force Meter/Kilogram/Kelvin', symbol: 'kgf·m/(kg·K)', factor: 9.80665 },
    { name: 'Pound-Force Foot/Pound/Degree Rankine', symbol: 'lbf·ft/(lb·°R)', factor: 5.380 },
    
    // BTU-based units
    { name: 'Btu (IT)/Pound/Degree Fahrenheit', symbol: 'Btu (IT)/(lb·°F)', factor: 4186.8 },
    { name: 'Btu (th)/Pound/Degree Fahrenheit', symbol: 'Btu (th)/(lb·°F)', factor: 4184 },
    { name: 'Btu (IT)/Pound/Degree Rankine', symbol: 'Btu (IT)/(lb·°R)', factor: 4186.8 },
    { name: 'Btu (th)/Pound/Degree Rankine', symbol: 'Btu (th)/(lb·°R)', factor: 4184 },
    { name: 'Btu (IT)/Pound/Degree Celsius', symbol: 'Btu (IT)/(lb·°C)', factor: 2326 },
    { name: 'CHU/Pound/Degree Celsius', symbol: 'CHU/(lb·°C)', factor: 4186.8 }
  ]
};
